export const CV_ANALYZER_API_BASE_URL = "https://resume.plasma.nucleusteq.com/cvanalyzer"